import { Location, locationName } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const PassageHistoryPage = lazy(() => import('../pages/PassageHistoryPage'));
const PassageHistoryResultsPage = lazy(() => import('../pages/PassageHistoryResultsPage'));

const routes = [
  {
    title: locationName[Location.PASSAGE_HISTORY],
    path: Location.PASSAGE_HISTORY,
    team: 'squad-gf-core',
    exact: true,
    component: PassageHistoryPage,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.PASSAGE_HISTORY_RESULTS],
    path: Location.PASSAGE_HISTORY_RESULTS,
    team: 'squad-gf-core',
    exact: true,
    component: PassageHistoryResultsPage,
    needsGoogleMaps: true,
  },
];

export default routes;
